import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { Router } from './routes/route';
import ProductGridLayoutProvider from "./components/GridLayout/ProductGridLayoutProvider";

function App() {
  return (
    <div className="rims-app">
      <ProductGridLayoutProvider>
        <RouterProvider router={Router} />
      </ProductGridLayoutProvider>
    </div>
  );
}

export default App;
